import { useLocation } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  alpha,
} from "@mui/material";
import { Link } from "react-router-dom";
import { adminLinks } from "./adminLinks";

type Props = {
  onNavigate?: () => void;
};

const LinksDrawer = ({ onNavigate }: Props) => {
  const location = useLocation();

  const isActive = (path: string) => {
    const linkPath = path.split("?")[0];
    if (linkPath === "/") return location.pathname === "/";
    return (
      location.pathname === linkPath ||
      location.pathname.startsWith(`${linkPath}/`)
    );
  };

  return (
    <List sx={{ px: 1.5, py: 0.5 }}>
      {adminLinks.map((link) => {
        const Icon = link.icon;
        const active = isActive(link.path);

        return (
          <ListItem key={link.path} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              component={Link}
              to={link.path}
              selected={active}
              onClick={onNavigate}
              sx={(theme) => ({
                py: 1.25,
                px: 1.5,
                borderRadius: 2.5,
                color: active ? "primary.main" : "text.secondary",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: alpha(theme.palette.primary.main, 0.06),
                  color: "primary.main",
                },
                "&.Mui-selected": {
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  color: "primary.main",
                  fontWeight: 600,
                  "&:hover": {
                    bgcolor: alpha(theme.palette.primary.main, 0.14),
                  },
                  "& .MuiListItemIcon-root": {
                    color: "primary.main",
                  },
                },
              })}
            >
              <ListItemIcon
                sx={{
                  minWidth: 40,
                  color: "inherit",
                  "& svg": { width: 22, height: 22 },
                }}
              >
                <Icon />
              </ListItemIcon>
              <ListItemText
                primary={link.title}
                primaryTypographyProps={{
                  fontSize: "0.875rem",
                  fontWeight: active ? 600 : 500,
                  lineHeight: 1.4,
                }}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default LinksDrawer;
